// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookTransferReminderLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/BookTransferReminderLayout/BookTransferReminderLayout.scss
 ** module id = 950
 ** module chunks = 1
 **/